import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const STAFF_ROLES = ["super_admin", "admin", "editor"];

export default function ProtectedRoute({ children, requireAdmin = true }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Memverifikasi sesi...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (requireAdmin && !STAFF_ROLES.includes(user.role)) return <Navigate to="/admin/login" replace />;
  return children;
}
